module.exports = __webpack_public_path__ + "static/7-b542495c21d7f4389c05e28e5fde0981.jpg";